import Toggle from '@ui/Toggle';
import { slugify } from '@util/urlHelpers';
import React from 'react';

const PageSection = ({
  title,
  children,
  error,
  required,
  className,
  switchTitle,
  switchOnChange,
  switchEnabled,
  showSwitch = true,
  headerClassName,
}: {
  title: string;
  children?: React.ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
  switchTitle?: string;
  switchOnChange?: () => void;
  switchEnabled?: boolean;
  showSwitch?: boolean;
  headerClassName?: string;
}) => {
  return (
    <div
      className="mt-8 h-full w-full rounded-[1.5rem] border border-zinc-200 bg-white p-16 shadow-sm"
      id={slugify(title)}
    >
      <div
        className={`${headerClassName} relative flex items-center justify-between`}
      >
        <div
          className={
            'flex flex-col items-start gap-y-4 sm:flex-row sm:items-center'
          }
        >
          <div className="flex items-center">
            <h3 className="text-[2.4rem] font-medium">{title}</h3>

            {required && <span className="mx-[0.8rem] text-brand-red">*</span>}
          </div>

          {error && <p className="text-[1.3rem] text-brand-red">{error}</p>}
        </div>

        {showSwitch && switchOnChange && (
          <Toggle
            label={switchTitle}
            onChange={switchOnChange}
            enabled={switchEnabled ?? false}
          />
        )}
      </div>

      <div className={className}> {children}</div>
    </div>
  );
};

export default PageSection;
